export default __webpack_public_path__ + "static/media/explore2_screenshot1.d8ef1f80.png";